class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.container = document.getElementById('CartDrawer');
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, '_', this.dataset.variantId);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);



    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === this.tagName.toLowerCase()) {
        return;
      }
      this.onCartUpdate();
      const safeCount = (event && event.cartData && typeof event.cartData.item_count === 'number')
          ? event.cartData.item_count
          : (Array.isArray(event?.cartData?.items)
              ? event.cartData.items.reduce((sum, i) => sum + (i?.quantity || 0), 0)
              : null);

      if (typeof safeCount === 'number' && !Number.isNaN(safeCount)) {
        updateCartCounters(safeCount);
      }
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  updateProgressBar() {

    window.updateCartThresholdBar();
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          this.updateProgressBar();
        })
        .then((html)=>{
          this.validateGiftConditions(html)
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');

          this.innerHTML = sourceQty.innerHTML;

          const freshCart = JSON.parse(responseText);
           refreshAllBars(freshCart.total_price);
           fireCartUpdated(freshCart);
        })
        .then((html)=>{
          this.validateGiftConditions(html)
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  validateGiftConditions(html = null) {
    const root = html || document;

    let giftCodes = [];
    let cartAmount = 0
    let giftCodeEl = root.querySelector('.gift-codes');
    let giftForRemove = {}
    let giftForAdd = {}

    if (!giftCodeEl) return;

    try {
      const parsed = JSON.parse(giftCodeEl.textContent);
      giftCodes = parsed.codes || [];
      cartAmount = parsed.cart_amount || 0;
    } catch (e) {
      console.error('gift-codes JSON:', e);
      return;
    }

    const giftItems = root.querySelectorAll('.gift-line-item');
    const giftItemIdsInCart = Array.from(giftItems).map(item => item.getAttribute('data-item-id'));
    const cartItems = root.querySelectorAll('.cart-item:not(.gift-line-item)');

    if (!giftItems.length && !giftCodes.length && !cartItems.length) {
      this.updateQuantity(0, 0, '_', 0)
    }

    if(!giftCodes.length){
      giftItems.forEach(item => {
        giftForRemove[item.getAttribute('data-item-id')] = 0;
      })
    }

    if (Object.keys(giftForRemove).length){
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          updates: giftForRemove
        })
      })
          .then(() => {
            this.onCartUpdate();
            this.updateCounter();
          })
          .catch(e => console.error("Remove err", e));
    }

    if (giftCodes.length) {
      fetch('https://www.metagenics.com.au/apps/datajet/task/68a43ac66a53f96150421128', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          giftCodes: giftCodes,
          giftItems: Array.from(giftItems).map((item) => {
            return {
              id: item.getAttribute('data-item-id'),
            };
          }),
        }),
      })
          .then(response => response.json())
          .then(data => {
            console.log('data:', data);
            if (data.gift_data.length){
              data.gift_data.forEach((gift) => {
                let conditions = JSON.parse(gift.conditions);
                if(conditions && conditions[0].minimumRequirement === "DiscountMinimumSubtotal" && cartAmount > Number(conditions[0].min_amount) || conditions && conditions[0].minimumRequirement === ""){
                  giftForAdd[gift.product_id] = 1;
                } else if(conditions && conditions[0].minimumRequirement === "DiscountMinimumQuantity" && cartItems.length >= Number(conditions[0].min_quantity)){
                  giftForAdd[gift.product_id] = 1;
                }
              })
            }

            giftItemIdsInCart.forEach(giftID => {
              if (!giftForAdd[giftID]) {
                giftForRemove[giftID] = 0;
              }
            });

            Object.keys(giftForAdd).forEach(productId => {
              if (!giftItemIdsInCart.includes(productId) && giftForAdd[productId]) {
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                  },
                  body: JSON.stringify({
                    id: productId,
                    quantity: giftForAdd[productId]
                  })
                })
                    .then(() => {
                      this.onCartUpdate();
                      this.updateCounter();
                    })
                    .catch(e => console.error('Add', e));
              }
            });

            if (Object.keys(giftForRemove).length) {
              fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                },
                body: JSON.stringify({
                  updates: giftForRemove
                })
              })
                  .then(() => {
                    this.onCartUpdate();
                    this.updateCounter();
                  })
                  .catch(e => console.error('Remove', e));
            }
          })
          .catch(e => {
            console.error('error:', e);
          });
    }
  }

  updateCounter(){
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
        .then(res => res.text())
        .then(html => {
          const bubbleHTML = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('.shopify-section');

          const bubble = document.getElementById('cart-icon-bubble');
          const count = bubbleHTML.querySelector('[data-count]').getAttribute('data-count');

          if (bubble && bubbleHTML) {
            bubble.innerHTML = bubbleHTML.innerHTML;
          }

          updateCartCounters(count);
        });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        refreshAllBars(parsedState.total_price)
        updateCartCounters(parsedState.item_count);
        fireCartUpdated(parsedState);
        publish(PUB_SUB_EVENTS.cartUpdate, {
               source: this.tagName.toLowerCase(),
               cartData: parsedState,
               variantId,
             });
      })
      .then((parsedState) => {
        this.validateGiftConditions(parsedState)
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

function updateCartCounters(count) {
  document.querySelectorAll('cart-count').forEach((el) => {
    let textItem = count === 1 ? 'item' : 'items';

    el.textContent = `${count} ${textItem}`;
  });
}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/**
 *
 * @param {number|null} newTotalCents
 * @param {HTMLElement|null} barEl
 */
window.updateCartThresholdBar = function (newTotalCents = null, barEl = null) {

  const bar = barEl || document.querySelector('.cart-progress-bar');
  if (!bar) return;

  const barType      = bar.dataset.barType;
  const totalCents   = (newTotalCents ?? parseInt(bar.dataset.cartTotal, 10)) || 0;

  const steps= [...bar.querySelectorAll('.progress-step')];
  const progressBar  = bar.querySelector('.progress-bar');
  const amountAwayEl = bar.querySelector('[id="amount-away"]');
  const amountPctEl  = bar.querySelector('[id="amount-away_percent"]');
  const finalMsgEl   = bar.querySelector('[id="final_message_progress_bar"]');
  const initialMsgs  = bar.querySelectorAll('.initial_message');
  const lastPartEl   = bar.querySelector('[id="last-part"]');

  steps.forEach(step => {
    step.classList.remove('completed', 'active', 'hidden');
    if (step.dataset.threshold === '' || isNaN(parseInt(step.dataset.threshold, 10))) {
      step.classList.add('hidden');
    }
  });

  let nextThreshold     = null;
  let nextDiscount      = null;
  let activeStepIndex   = -1;

  steps.forEach((step, idx) => {
    if (step.classList.contains('hidden')) return;

    const threshold    = parseInt(step.dataset.threshold, 10);
    const discountText = step.querySelector('.message_tresholds').textContent.trim();

    if (totalCents >= threshold) {
      step.classList.add('completed');
    } else if (nextThreshold === null) {
      step.classList.add('active');
      nextThreshold   = threshold;
      activeStepIndex = idx;

      const m = discountText.match(/((?:\d+%\s*off)|(?:\$\s*[\d,.]+\s*off|[\d,.]+\s*\$\s*off)|(?:\d+%)|free shipping)/i);
      nextDiscount = m ? m[0].toLowerCase() : discountText.toLowerCase();
    }
  });

  if (nextThreshold !== null) {
    const diffDollars = ((nextThreshold - totalCents) / 100).toFixed(2);
    amountAwayEl.textContent = `$${diffDollars}`;

    let label, hideTail = false;

    /* 1. Free Shipping */
    if (nextDiscount === 'free shipping') {
      label     = 'Free Shipping';
      hideTail  = true;


    } else if (nextDiscount.includes('free') && nextDiscount.includes('product')) {

      label     = 'free product';
      hideTail  = true;

    } else {
      label = nextDiscount.toLowerCase().includes('free')
        ? nextDiscount.toUpperCase()
        : `${nextDiscount.toUpperCase()}`;
      hideTail  = false;
    }

    amountPctEl.textContent  = label;
    lastPartEl?.classList.toggle('hidden', hideTail);

  } else {

    amountAwayEl.textContent = '$0.00';
    amountPctEl.textContent  = 'All rewards unlocked!';
    finalMsgEl.style.display = 'block';
    initialMsgs.forEach(el => el.style.display = 'none');
    lastPartEl?.classList.add('hidden');
  }

  const progressSteps   = [...bar.querySelectorAll('.progress-step')];
  const tot     = totalCents;
  const limits  = progressSteps.map(s => +s.dataset.threshold).sort((a,b)=>a-b);
  const lastLim = limits.at(-1);

  if (progressSteps.length === 1) {
    const capPct   = 75;
    const pctUntil = Math.min(tot / lastLim * capPct, capPct);

    progressBar.style.setProperty(
        '--progress-width',
        tot >= lastLim ? '100%' : `${pctUntil}%`
    );
    return;
  }

  const sectors   = progressSteps.length + 1;
  const sectorPct = 100 / sectors;

  if (tot >= lastLim) {
    progressBar.style.setProperty('--progress-width', '100%');
    return;
  }

  const idx = limits.findIndex(l => tot < l);
  const prev = idx === 0 ? 0 : limits[idx - 1];
  const next = limits[idx];
  const part = (tot - prev) / (next - prev);

  const percent = (idx + part) * sectorPct;
  progressBar.style.setProperty('--progress-width', `${percent}%`);


};

function refreshAllBars(totalCents) {
  document
      .querySelectorAll('.cart-progress-bar')
      .forEach((bar) => {
        bar.dataset.cartTotal = totalCents;
        window.updateCartThresholdBar(totalCents, bar);
      });
}

function updateCartCounters(count) {
  if (typeof count !== 'number' || !Number.isFinite(count)) return;
  document.querySelectorAll('cart-count').forEach((el) => {
    let textItem = count === 1 ? 'item' : 'items';

    el.textContent = `${count} ${textItem}`;
  });
}

function fireCartUpdated(cartData) {
  document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles : true,
        detail  : {cart: cartData}
      })
  );
}